
namespace Matrix.Data {

    /**
     * Checks if the date is in the past.
     * Converts today and paramter to "yyyy-MM-dd" format.
     * @returns {true} if date is in the past.
     * @returns {false} if date is today or in the future.
     */
    export function isDateInPast(date: string | Date): boolean {
        return Q.formatDate(date, "yyyy-MM-dd") < Q.formatDate(new Date(), "yyyy-MM-dd");
    };

    @Serenity.Decorators.registerClass()
    export class TestResultMutingDialog extends Serenity.PropertyDialog<TestResultRow, any> {

        private form: TestResultMutingForm = new TestResultMutingForm(this.idPrefix);

        constructor() {
            super();

            this.dialogTitle = "Mute Test Result";
            this.form.UntilWhen.addValidationRule(this.uniqueName, () => {
                if (isDateInPast(this.form.UntilWhen.valueAsDate))
                    return "Date entered is in the past!"
            });
        }

        public execute(request: TestResultMutingRequest) {
            this.propertyGrid.load(request);
            this.dialogOpen();

            if (isDateInPast(request.UntilWhen))
                return

            $('<button type="button" class="ui-button ui-corner-all ui-widget">Unmute</button>').appendTo(this.element.parent().find('.ui-dialog-buttonpane')).click(() => {
                TestResultMuteService.Delete({
                    EntityId: request.MuteId
                }, () => {
                    Q.notifySuccess("Unmuted test result.");
                    this.dialogClose();
                });
            });
        }

        protected okClickValidated() {
            var request = this.getSaveEntity() as TestResultMutingRequest;
            TestResultService.Mute(request, () => {
                Q.notifySuccess("Muted test result.");
                this.dialogClose();
            });
        }
    }
}